
import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import Passenger from "@/components/Passenger/models/Passenger";
import AddPassengerToPassengerGroupForm from "@/components/Organization/AddPassengerToPassengerGroup/AddPassengerToPassengerGroupForm.vue";
import vuetifyToast from "vuetify-toast";
import { IPassengerGroupWithPassengers } from '@/typings/timit';

@Component({
  components: {
    AddPassengerToPassengerGroupForm
  }
})
export default class AddPassengerToPassengerGroupDialog extends Vue {
  @Prop({ default: false }) private open!: boolean;
  @Prop({ required: true }) private passengerGroup!: IPassengerGroupWithPassengers;

  async addPassenger(passenger: Passenger) {
    const existingPassenger = passenger.id > 0;
    if (existingPassenger) {
      const request = {
        PassengerGroupId: this.passengerGroup.id,
        PassengerIds: [ passenger.id ],
      }
      try {
        await this.$store.dispatch('organization/addPassengerToPassengerGroup', { data: request }).then(p => {
          p.data.forEach(passenger => {
            const mainDestinationId = passenger.destinationIds.find(d => d);
            const destination = this.$store.getters['organization/getDestinationById'](mainDestinationId);
            if (destination) {
              this.$store.commit('organization/updatePassengerGroupPassengersDestination',{ passengerId: passenger.id, destination: destination });
            }
          });
        });

        vuetifyToast.success( this.$i18n.translate("passenger.save.success", "Passenger saved successfully."));
        this.closeDialog();
      } catch (error) {
        vuetifyToast.error(this.$i18n.translate("passenger.save.error.generic", "There was an error saving the passenger. Please try again later."));
      }
    }
  }

  closeDialog() {
    this.$emit('close');
  }
}
